/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {init as ɵa} from './edw-fwk-angular-lib.module';